// import React, { useEffect, useRef } from "react";

// const AnimatedSCanvas = () => {
//   const canvasRef = useRef(null);
//   const mouse = { x: 0, y: 0 };

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let width = (canvas.width = window.innerWidth);
//     let height = (canvas.height = window.innerHeight);

//     const fontSize = Math.min(width, height) * 0.9;
//     let particles = [];
//     let backgroundDots = [];
//     let morph = false;
//     let scatter = false;
//     let scatterStartTime = 0;
//     const scatterDuration = 3000; // 3 seconds
//     const scatterInterval = 7000; // 6 seconds
//     let lastScatterTime = Date.now();

//     const getTextCoordinates = () => {
//       ctx.clearRect(0, 0, width, height);
//       ctx.fillStyle = "#4dc6f2ff";
//       ctx.font = `${fontSize}px fantasy`;
//       ctx.textAlign = "right";
//       ctx.textBaseline = "middle";
//       ctx.fillText("S", width / 2, height / 2);

//       const data = ctx.getImageData(0, 0, width, height);
//       const targets = [];

//       for (let y = 0; y < height; y += 8) {
//         for (let x = 0; x < width; x += 8) {
//           const i = (y * width + x) * 4;
//           if (data.data[i + 3] > 128) {
//             targets.push({ x, y });
//           }
//         }
//       }

//       return targets;
//     };

//     const initParticles = (targets) => {
//       particles = targets.map((t) => ({
//         x: Math.random() * width,
//         y: Math.random() * height,
//         tx: t.x,
//         ty: t.y,
//         r: Math.random() * 1,
//         color: "#4dc6f2ff",
//         vx: 0,
//         vy: 0,
//         floatAngle: Math.random() * Math.PI * 2,
//       }));

//       backgroundDots = Array.from({ length: 100 }).map(() => ({
//         x: Math.random() * width,
//         y: Math.random() * height,
//         r: Math.random() * 1.2 + 0.3,
//         baseAlpha: Math.random() * 0.4 + 0.1,
//         angle: Math.random() * Math.PI * 2,
//         speed: Math.random() * 0.5 + 0.2,
//       }));
//     };

//     const scatterParticles = () => {
//       scatter = true;
//       scatterStartTime = Date.now();
//       particles.forEach((p) => {
//         const angle = Math.random() * Math.PI * 2;
//         const speed = Math.random() * 3 + 1;
//         p.vx = Math.cos(angle) * speed;
//         p.vy = Math.sin(angle) * speed;
//       });
//     };

//     const animate = () => {
//       ctx.clearRect(0, 0, width, height);
//       const now = Date.now();

//       if (now - lastScatterTime > scatterInterval) {
//         scatterParticles();
//         lastScatterTime = now;
//       }

//       backgroundDots.forEach((dot) => {
//         dot.angle += dot.speed * 0.01;
//         const dx = mouse.x - dot.x;
//         const dy = mouse.y - dot.y;
//         const dist = Math.sqrt(dx * dx + dy * dy);
//         let alpha = dot.baseAlpha;
//         if (dist < 80) alpha = 0;

//         ctx.beginPath();
//         ctx.arc(dot.x, dot.y, dot.r, 0, Math.PI * 2);
//         ctx.fillStyle = `rgba(255, 213, 79, ${alpha})`;
//         ctx.fill();
//       });

//       particles.forEach((p) => {
//         const dx = mouse.x - p.x;
//         const dy = mouse.y - p.y;
//         const dist = Math.sqrt(dx * dx + dy * dy);
//         let hoverEffect = 0;
//         if (dist < 80) {
//           hoverEffect = Math.sin(now * 0.1 + p.y) * 12;
//         }

//         if (scatter && now - scatterStartTime < scatterDuration) {
//           p.x += p.vx;
//           p.y += p.vy;
//         } else {
//           if (scatter && now - scatterStartTime >= scatterDuration) {
//             scatter = false;
//           }

//           p.floatAngle += 0.05;
//           const fx = Math.cos(p.floatAngle) * 0.5;
//           const fy = Math.sin(p.floatAngle) * 0.5;
//           p.x += (p.tx - p.x) * 0.05 + fx;
//           p.y += (p.ty - p.y) * 0.05 + fy;
//         }

//         ctx.beginPath();
//         ctx.arc(p.x, p.y + hoverEffect, p.r, 0, Math.PI * 2);
//         ctx.fillStyle = p.color;
//         ctx.fill();
//       });

//       requestAnimationFrame(animate);
//     };

//     const setup = () => {
//       width = canvas.width = window.innerWidth;
//       height = canvas.height = window.innerHeight;
//       const targets = getTextCoordinates();
//       initParticles(targets);
//       animate();
//     };

//     const handleMouseMove = (e) => {
//       const rect = canvas.getBoundingClientRect();
//       mouse.x = e.clientX - rect.left;
//       mouse.y = e.clientY - rect.top;
//     };

//     window.addEventListener("resize", setup);
//     canvas.addEventListener("mousemove", handleMouseMove);
//     setup();

//     return () => {
//       window.removeEventListener("resize", setup);
//       canvas.removeEventListener("mousemove", handleMouseMove);
//     };
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       style={{
//         position: "fixed",
//         top: "10%",
//         // right: "90%",
//         width: "100vw",
//         height: "100vh",
//         zIndex: -1,
//         display: "block",
//         alignItems:"right",

        
//         // background: "#000", // optional black background
//       }}
//     />
//   );
// };

// export default AnimatedSCanvas;



// New code-------------------------

import React, { useEffect, useRef } from "react";

const AnimatedSCanvas = () => {
  const canvasRef = useRef(null);
  const mouse = { x: 0, y: 0 };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = canvas.offsetWidth;
    let height = canvas.offsetHeight;

    const fontSize = Math.min(width, height) * 0.9;
    let particles = [];
    let backgroundDots = [];
    let scatter = false;
    let scatterStartTime = 0;
    const scatterDuration = 3000;
    const scatterInterval = 7000;
    let lastScatterTime = Date.now();

    const getTextCoordinates = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = "#3898f8";
      ctx.font = `${fontSize}px fantasy`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("S", width / 2, height / 2);

      const data = ctx.getImageData(0, 0, width, height);
      const targets = [];

      for (let y = 0; y < height; y += 4) {
        for (let x = 0; x < width; x += 4) {
          const i = (y * width + x) * 4;
          if (data.data[i + 3] > 128) {
            targets.push({ x, y });
          }
        }
      }

      return targets;
    };

    const initParticles = (targets) => {
      particles = targets.map((t) => ({
        x: Math.random() * width,
        y: Math.random() * height,
        tx: t.x,
        ty: t.y,
        r: Math.random() * 1,
        color: "#4dc6f2ff",
        vx: 0,
        vy: 0,
        floatAngle: Math.random() * Math.PI * 2,
      }));

      backgroundDots = Array.from({ length: 100 }).map(() => ({
        x: Math.random() * width,
        y: Math.random() * height,
        r: Math.random() * 1.2 + 0.3,
        baseAlpha: Math.random() * 0.4 + 0.1,
        angle: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.5 + 0.2,
      }));
    };

    const scatterParticles = () => {
      scatter = true;
      scatterStartTime = Date.now();
      particles.forEach((p) => {
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * 1.5 + 0.5; // slowed down
        p.vx = Math.cos(angle) * speed;
        p.vy = Math.sin(angle) * speed;
      });
    };

    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      const now = Date.now();

      if (now - lastScatterTime > scatterInterval) {
        scatterParticles();
        lastScatterTime = now;
      }

      backgroundDots.forEach((dot) => {
        dot.angle += dot.speed * 0.01;
        const dx = mouse.x - dot.x;
        const dy = mouse.y - dot.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        let alpha = dot.baseAlpha;
        if (dist < 80) alpha = 0;

        ctx.beginPath();
        ctx.arc(dot.x, dot.y, dot.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 213, 79, ${alpha})`;
        ctx.fill();
      });

      particles.forEach((p) => {
        const dx = mouse.x - p.x;
        const dy = mouse.y - p.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        let hoverEffect = 0;
        
        if (dist < 80) {
          hoverEffect = Math.sin(now * 0.1 + p.y) * 12;
        }

        if (scatter && now - scatterStartTime < scatterDuration) {
          p.x += p.vx;
          p.y += p.vy;
        } else {
          if (scatter && now - scatterStartTime >= scatterDuration) {
            scatter = false;
          }

          p.floatAngle += 0.05;
          const fx = Math.cos(p.floatAngle) * 0.5;
          const fy = Math.sin(p.floatAngle) * 0.5;
          p.x += (p.tx - p.x) * 0.05 + fx;
          p.y += (p.ty - p.y) * 0.05 + fy;
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y + hoverEffect, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });

      requestAnimationFrame(animate);
    };

    const setup = () => {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
      const targets = getTextCoordinates();
      initParticles(targets);
      animate();
    };

    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    };

    window.addEventListener("resize", setup);
    // canvas.addEventListener("mousemove", handleMouseMove);
    setup();

    return () => {
      window.removeEventListener("resize", setup);
      canvas.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        width: "100%",
        height: "100%",
        display: "block",
      }}
    />
  );
};

export default AnimatedSCanvas;

